export interface FeatureFlag {
  title: string;
  description: string;
  localStorageKey: string;
  autoAssignTrafficPercentage?: number;
  disableAfterDate?: Date;
  betaUsers?: Set<string>;
}

const flags = {
  TRANSLATE_BUTTON: {
    title: 'Show translate button',
    description: 'Turn on to show Translate with Google button',
    localStorageKey: 'translate_button',
  },
  TRIP_PAID_BUSINESS_LAYER: {
    title: 'tripPaid via business layer',
    description:
      'Turn on to make the tripPaid event go through the business layer instead of withlocals-analytics',
    localStorageKey: 'tripPaidViaBusinessLayer',
  },
};

function getOrElse(key: string, orElse: string) {
  try {
    const value = localStorage.getItem(key);
    if (value === null || value === undefined) return orElse;
    return value;
  } catch (e) {
    return orElse;
  }
}

function getParseOrElse<T>(key: string, orElse: T) {
  return JSON.parse(getOrElse(key, JSON.stringify(orElse))) as T;
}

function setJson(key: string, value: any) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    return;
  }
}

function setFlag(flag: FeatureFlag, value: boolean) {
  setJson(flag.localStorageKey, value);
}

function autoAssignIfNeeded(flag: FeatureFlag) {
  if (!flag.autoAssignTrafficPercentage) return;
  const isAutoAssigned = getParseOrElse<boolean>(
    `${flag.localStorageKey}.autoassigned`,
    false,
  );
  if (!isAutoAssigned) {
    // auto assign
    const value = Math.random() * 100;
    const flagValue = value <= flag.autoAssignTrafficPercentage;
    console.log('auto assigning feature flag', flag, flagValue);
    setJson(`${flag.localStorageKey}.autoassigned`, true);
    setFlag(flag, flagValue);
  }
}

function isSet(flag: FeatureFlag): boolean {
  autoAssignIfNeeded(flag);
  return getParseOrElse(flag.localStorageKey, false);
}

function toggleFlag(flag: FeatureFlag) {
  return setFlag(flag, !isSet(flag));
}

const flagList: FeatureFlag[] = Object.values(flags);

const serializeFeatureFlags = () => {
  return flagList
    .filter(isSet)
    .map((item) => item.localStorageKey)
    .join(',');
};
const setFeatureFlagsFromSerialized = (input: string) => {
  const flags = input
    .split(',')
    .map((ff) => flagList.find((item) => item.localStorageKey === ff))
    .filter((x) => !!x);
  if (flags && flags.length > 0) {
    flags.forEach((flag) => (isSet(flag) ? null : toggleFlag(flag)));
  }
};

export default {
  setFeatureFlagsFromSerialized,
  serializeFeatureFlags,
  flags,
  flagList,
  isSet,
  toggleFlag,
};
